<template>
  <div class="qr-code-block">
    <div class="block-title">
      <span class="text"
            v-html="hint"
            v-if="hint"
      >
      </span>
    </div>
    <div class="qr-code-container">
      <div class="title"
           v-if="!hideQrCodeName"
      >
        {{ qrCode.name }}
      </div>
      <ym-img v-if="qrCode.src !== ''"
              class="qr-code"
              :src="qrCode.src"
              :alt="qrCode.name"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ServiceQrCodeBlock',
    props: {
      qrCode: {
        type: Object,
        required: true,
      },
      hideQrCodeName: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      hint() {
        const { qrCode } = this;
        return qrCode.hint || '关注公众号，即可收到提醒';
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .qr-code-block {
    text-align: center;
  }

  .block-title {
    display: inline-block;
    color: @color-white;
    background-color: @color-primary;
    padding: (@size-extra-small * 1.5) 50px;
    border-radius: @border-radius-large;
    position: relative;
    margin-bottom: @size-medium;
    .text {
      position: relative;
      z-index: @z-index-large;
    }
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: -.9em;
      display: block;
      padding: .6em;
      background-color: inherit;
      border-radius: @border-radius-base;
      transform: rotate(45deg) translateX(-50%);
    }
  }

  .title {
    margin-bottom: @size-small;
    font-size: @font-size-large;
    line-height: 1;
    font-weight: @font-weight-primary;
  }

  @qr-code-size: 258px;
  .qr-code {
    display: block;
    width: @qr-code-size;
    height: @qr-code-size;
    margin: 0 auto;
    border: @border-base;
  }

  .desc {
    color: @color-text-light;
    font-size: @font-size-base;
  }
</style>
